import { Loader2 } from 'lucide-react';
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { cn } from '@shared/utils';

import { buttonVariants, type ButtonVariants } from './button.variants';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, ButtonVariants {
  readonly isLoading?: boolean;
  readonly leftIcon?: ReactNode;
  readonly rightIcon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    className,
    variant,
    size,
    fullWidth,
    isLoading = false,
    disabled,
    leftIcon,
    rightIcon,
    children,
    type,
    ...rest
  },
  ref,
) {
  const isInteractionDisabled = disabled === true || isLoading;

  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cn(buttonVariants({ variant, size, fullWidth }), className)}
      aria-busy={isLoading ? true : undefined}
      aria-disabled={isInteractionDisabled ? true : undefined}
      disabled={isInteractionDisabled}
      {...rest}
    >
      {isLoading && (
        <Loader2 className="size-4 animate-spin" aria-hidden="true" />
      )}
      {!isLoading && leftIcon !== undefined && leftIcon !== null && (
        <span aria-hidden="true" className="inline-flex">
          {leftIcon}
        </span>
      )}
      <span>{children}</span>
      {!isLoading && rightIcon !== undefined && rightIcon !== null ? (
        <span aria-hidden="true" className="inline-flex">
          {rightIcon}
        </span>
      ) : null}
    </button>
  );
});
